import React from "react";
import { Card, CardBody } from "reactstrap";

const AuthCard = ({ children }: { children: React.ReactNode }) => (
  <Card className="auth-card">
    <CardBody className="p-4">{children}</CardBody>
  </Card>
);

export default React.memo(AuthCard);
